import { createAsyncThunk } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { ILetter } from 'features/EngineeringNetStatus/EngineeringInfo/GuaranteeLetter/types';

export const getGaranteeLetter = createAsyncThunk(
  'EN_guaranteeLetter/getGaranteeLetter',
  async (id: number, thinkApi) => {
    try {
      const { data } = await get<ILetter>(
        `/api/standards/engineering_networks/${id}/guarantee-letter/`,
      );
      return data;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);
